import { render, staticRenderFns } from "./CalendarioCitas.vue?vue&type=template&id=abc3c20c&"
import script from "./CalendarioCitas.vue?vue&type=script&lang=js&"
export * from "./CalendarioCitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports